<template>
  <div class="image-picker">
    <div class="form-group">
      <div class="row">
        <div class="col-12" v-if="image_url">
          <div class="form-group">
            <label>Gekozen afbeelding</label>
            <img class="img-fluid img-fluid-100" :src="image_url" />
          </div>
        </div>
        <div class="col-12">
          <bs-input
            label="Afbeelding voor uw artikel"
            name="search"
            classname="image-picker-input"
            v-model="search"
            :placeholder="placeholder"
            :disabled="disabled"
          ></bs-input>
          <div class="images-wrapper">
            <div class="spinner-border text-primary mx-auto d-block my-2" role="status" v-if="loading">
              <span class="sr-only">Loading...</span>
            </div>
            <p v-if="total === 0 && !loading" class="mx-2 my-2">
              Helaas hebben wij geen afbeelding die aan uw zoekopdracht voldoet. Voer een algemenere zoekopdracht in
            </p>
            <div class="images" v-if="!loading && images.length > 0">
              <div v-for="rimage in images" :key="rimage.id" :class="{ selected: rimage.id === image }">
                <img :src="rimage.src.medium" v-on:click="select(rimage)" />
                <i class="fas fa-check checkmark"></i>
              </div>
            </div>
            <div class="images-footer d-flex justify-content-between align-items-center" v-if="!loading && images.length > 0">
              <div class="images-footer_information">
                Totaal: <b>{{ this.total }}</b>
              </div>
              <div class="images-footer_actions">
                <button type="button" class="btn btn-sm btn-outline-dark" :disabled="page === 1" v-on:click="prev">
                  <i class="fas fa-chevron-left"></i>
                  Vorige
                </button>
                <button type="button" class="btn btn-sm btn-outline-dark" :disabled="page * per_page >= total" v-on:click="next">
                  Volgende
                  <i class="fas fa-chevron-right"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="error" class="invalid-feedback animated fadeIn d-block">{{ $t(error) }}</div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import _ from 'lodash';

export default {
  props: {
    name: {
      type: String,
      required: true,
    },
    saved: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: 'Typ een woord in om te zoeken in onze database.'
    }
  },
  data: () => {
    return {
      loading: false,
      search: null,
      image: null,
      image_url: null,
      images: [],

      page: null,
      per_page: 15, //Weird limit thing
      total: null,
    };
  },
  watch: {
    search: _.debounce(function(val) {
      if (val && val.trim() != '' && val.length >= 2) {
        this.searchImages();
      }
    }, 500),
    image: function() {
      this.$emit('input', this.image);
    },
  },
  computed: {
    error: function() {
      if (this.$parent && this.$parent.errors) {
        if (this.$parent.errors[this.name]) {
          return this.$parent.errors[this.name][0];
        }
      }
    },
    classObject: function() {
      return {
        'is-invalid': this.error ? true : false,
      };
    },
  },
  created: function() {
    if (this.$attrs.value) {
      this.image = this.$attrs.value;
      this.image_url = this.saved
        ? route('images.show', this.image)
        : 'https://images.pexels.com/photos/' + this.image + '/pexels-photo-' + this.image + '.jpeg?auto=compress&h=350';
    }
  },
  methods: {
    reset: function() {
      this.search = null;
      this.image = null;
      this.image_url = null;
      this.images = [];
    },
    select: function(rimage) {
      this.image = rimage.id;
      this.image_url = rimage.src.medium;
    },
    prev: function() {
      this.page -= 1;
      this.searchImages();
    },
    next: function() {
      this.page += 1;
      this.searchImages();
    },
    searchImages: function() {
      this.loading = true;
      axios
        .post(route('images.search'), {
          term: this.search,
          page: this.page,
          per_page: this.per_page,
        })
        .then((response) => {
          this.loading = false;
          if (response.status == 200 && response.data) {
            if (response.data.success) {
              this.images = response.data.data.photos;
              this.page = response.data.data.page;
              this.total = response.data.data.total;
            }
          } else {
            this.error = response.data.message;
          }
        });
    },
  },
};
</script>
<style lang="scss">
.image-picker {
  .image-picker-input {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    border-bottom: 0;
  }

  .images-wrapper {
    border: 1px solid #e1e1e1;
    border-bottom: 0;

    .images {
      padding: 15px;
      columns: 2;

      > div {
        position: relative;
        margin: 0 0.5rem 0.5rem 0;

        .checkmark {
          display: none;
          position: absolute;
          width: 40px;
          height: 40px;
          text-align: center;
          background: #28a745;
          color: white;
          font-size: 20px;
          line-height: 40px;
          border-radius: 50%;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }

        &.selected {
          img {
            border: 2px solid #28a745;
          }

          .checkmark {
            display: block;
          }
        }

        img {
          width: 100%;
        }
      }
    }

    .images-footer {
      height: 30px;
      background: #e1e1e1;
      border-top: 1px solid #e1e1e1;

      .images-footer_information {
        margin-left: 15px;
      }
    }
  }
}
</style>
